
import Vue from 'vue'
import getConfig from '@config/appinfo.js'

class ConfigProvider {
  constructor(config) {
    this.config = JSON.parse(JSON.stringify(config))
  }
  async getConfig() {
    if (!this.config.version) {
      const config = await getConfig()
      this.config = config
    }
    return this.config
  }
}
const plugin = {
  install: function(Vue, options) {
    const clientProvider = new ConfigProvider({
    })
    Vue.appConfig = clientProvider
    Vue.prototype.$appConfig = clientProvider
    Vue.prototype.appConfig = clientProvider
  },
}
Vue.use(plugin)
export default plugin
